declare global {
  interface Window {
    beforeUnLoadEventHandler?: (event: BeforeUnloadEvent) => boolean;
  }
}

export class BeforeUnloadEventHandler {
  static register(): void {
    BeforeUnloadEventHandler.remove();
    window.beforeUnLoadEventHandler = event => {
      event.preventDefault();
      event.returnValue = '';
      return true;
    };
    window.addEventListener('beforeunload', window.beforeUnLoadEventHandler);
  }

  static remove(): void {
    window.removeEventListener('beforeunload', window.beforeUnLoadEventHandler, false);
    window.beforeUnLoadEventHandler = null;
  }
}
